// import "./wdyr";

import React from "react";
import ReactDOM from "react-dom";
import reduxThunk from "redux-thunk";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";

// Main CpeMod Application & Reducers
import CpeMod from "./CpeMod";
import reducers from "./reducers";

// Redux Dev Tools
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Create Redux Store & Enable Thunk
const store = createStore(
    reducers,
    composeEnhancers(applyMiddleware(reduxThunk))
);

ReactDOM.render(
    <Provider store={store}>
        <CpeMod />
    </Provider>,
    document.getElementById("root")
);
